/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useEffect } from 'react';
import { selectAccessToken } from 'modules/common/auth/selectors';
import { hasAnyRole } from 'modules/common/helpers/jwt';
import { Navigate } from 'react-router-dom';
import ROUTE from 'modules/common/constants/route';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../slice';

const PrivateRoute = ({ component: Component, roles }) => {
  /* determine if authorized, from context or however you're doing it */
  const accessToken = useSelector(selectAccessToken);
  //
  const dispatch = useDispatch();
  //
  const isAuthorized = hasAnyRole(accessToken, roles);
  //
  useEffect(() => {
    if (!isAuthorized) {
      dispatch(authActions.removeAuth());
    }
  }, [isAuthorized]);
  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  if (isAuthorized) {
    return <Component />;
  }
  //
  return <Navigate to={ROUTE.LOGIN} replace />;
};
//
export default PrivateRoute;
